import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { API } from "@/lib/api";

const AuthCtx = createContext(null);

function isGuestFlag() {
  try { return localStorage.getItem("iq-guest") === "1"; } catch (_) { return false; }
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    // Skip while returning from OAuth (AuthCallback establishes the session first).
    if (window.location.hash?.includes("session_id=")) { setLoading(false); return; }
    if (isGuestFlag()) {
      setUser({ name: "Guest", email: null, picture: null, role: "viewer", guest: true });
      setLoading(false);
      return;
    }
    try {
      const r = await fetch(`${API}/auth/me`, { credentials: "include" });
      if (r.ok) setUser({ ...(await r.json()), guest: false });
      else setUser(null);
    } catch (_) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return <AuthCtx.Provider value={{ user, loading, refresh, setUser }}>{children}</AuthCtx.Provider>;
}

export function useAuth() {
  return useContext(AuthCtx) || { user: null, loading: false, refresh: () => {}, setUser: () => {} };
}
